import { useTranslation } from 'react-i18next';
import type { LeadCloudFileType } from '@econtractor/types';
import { FilesCloudUpload } from 'modules/files';

interface NewTaskFilesTabProps {
    isSubmitting: boolean;
    cloudProgress: number | boolean;
    pendingCloudFiles: File[];
    setPendingCloudFiles: React.Dispatch<React.SetStateAction<File[]>>;
    templateFiles?: LeadCloudFileType[];
}

const NewTaskFilesTab = ({
    isSubmitting,
    cloudProgress,
    pendingCloudFiles,
    setPendingCloudFiles,
    templateFiles = [],
}: NewTaskFilesTabProps) => {
    const { t } = useTranslation(['Tasks', 'common']);

    return (
        <>
            {templateFiles.length > 0 ? (
                <div className="mb-3">
                    <div className="text-muted fs-12 mb-2">{t('directory.filesWillCopy')}</div>
                    <ul className="mb-0">
                        {templateFiles.map((file) => (
                            <li key={file.storageKey || file.fileName}>{file.fileName}</li>
                        ))}
                    </ul>
                </div>
            ) : null}
            <FilesCloudUpload
                disabled={isSubmitting}
                progress={cloudProgress}
                files={pendingCloudFiles}
                setFiles={setPendingCloudFiles}
                label={t('labelFiles')}
                buttonLabel={t('btnAttach')}
                uploadingLabel={t('common:buttons.uploading')}
            />
        </>
    );
};

export default NewTaskFilesTab;
